import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const Index = () => {
  const navigate = useNavigate();

  useEffect(() => {
    // Redirect to products page by default
    navigate('/products');
  }, [navigate]);

  return null;
};

export default Index;
